import { InAppReview } from "@capacitor-community/in-app-review";
import { getPlatform, isNativeApp } from "@/models/platform";
import { Share } from "@capacitor/share";
import { StatusBar, Style } from "@capacitor/status-bar";
import { ANDROID_APP_LINK, Colors, IOS_APP_LINK } from "@/constants";

export const requestReview = () => {
  if (isNativeApp()) {
    if (__DEV__) return;
    InAppReview.requestReview();
  }
};

export const shareApp = () => {
  if (getPlatform() === "android") {
    Share.share({
      title: "Download EZNOTE",
      text: "Never write notes again. Download EZNOTE now!",
      url: ANDROID_APP_LINK,
    });
  }

  if (getPlatform() === "ios") {
    Share.share({
      title: "Download EZNOTE",
      text: "Never write notes again. Download EZNOTE now!",
      url: IOS_APP_LINK,
    });
  }

  if (getPlatform() === "web") {
    window.open(ANDROID_APP_LINK, "_blank");
  }
};

export const setStatusBarStyleDark = async (color = Colors.bg) => {
  if (isNativeApp()) {
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color });
  }
};
